import { t } from 'i18next';

export const convertTimeMinutesToHours = (milliseconds: number) => {
  const totalSeconds = milliseconds / 1000;
  const totalMinutes = totalSeconds / 60;
  const totalHours = Math.floor(totalMinutes / 60);

  if (totalMinutes < 1) {
    const seconds = Math.round(totalSeconds);
    return { hours: 0, minutes: 0, seconds };
  }

  if (totalHours === 0) {
    return {
      minutes: Math.trunc(totalMinutes),
      seconds: Math.round(totalSeconds % 60),
    };
  }

  const minutesLeft = Math.round(totalMinutes % 60);
  return {
    hours: totalHours,
    minutes: minutesLeft,
  };
};

export const convertSecondsToTimeMinutesToHours = (seconds: number) => {
  const milliseconds = seconds * 1000;
  return convertTimeMinutesToHours(milliseconds);
};

export const convertTimeToString = (time: {
  minutes: number;
  hours?: number;
  seconds?: number;
}) => {
  const hour =
    time.hours !== 0 && time.hours !== undefined ? `${time.hours}h` : '';
  const minute = time.minutes > 0 ? `${time.minutes}m` : '';
  const seconds = time.seconds && time.seconds > 0 ? `${time.seconds}s` : '';

  return [hour, minute, seconds].join(' ').trim();
};

export const convertSecondsToTimeString = (seconds: number) => {
  if (seconds < 1) {
    return '<0s';
  }
  const time = convertSecondsToTimeMinutesToHours(seconds);
  return convertTimeToString(time);
};

const secondsInMinute = 60;
const secondsInHour = 60 * secondsInMinute;

export const secondsToTimePartials = (
  seconds: number,
): {
  hours?: number;
  minutes?: number;
} => {
  const hours = Math.floor(seconds / secondsInHour);
  seconds -= hours * secondsInHour;

  const minutes = Math.floor(seconds / secondsInMinute);

  return {
    hours,
    minutes,
  };
};

export const convertTimeSecondsToString = (
  nrOfSeconds: number,
  onlyHours?: boolean,
) => {
  if (!nrOfSeconds) {
    return `N/A`;
  }

  const { hours, minutes } = secondsToTimePartials(nrOfSeconds);

  const nrOfHours = (hours ?? 0).toString().padStart(2, '0');

  if (onlyHours) {
    return hours
      ? `${nrOfHours}${t('hour-simplified')}`
      : `<1${t('hour-simplified')}`;
  }

  const nrOfMinutes = (minutes ?? 0).toString().padStart(2, '0');

  return `${nrOfHours}${t('hour-simplified')}${nrOfMinutes !== '00' ? nrOfMinutes : ''}`;
};
